import {format, getDay, subDays, subYears} from "date-fns"
import parseISO from "date-fns/parseISO"

export function reformatDate(dateStr: string): string {
  try {
    return format(parseISO(dateStr), "dd/MM/yyyy")
  } catch {
    if (dateStr === undefined) {
      return ""
    }
    console.error("reformatDate(): Failed to parse date:", dateStr)
    return dateStr
  }
}

export function formatDate(date: Date): string | null {
  return format(date, "dd/MM/yyyy")
}

export function toYYYYMMDD(date: Date): string {
  return format(date, "yyyy-MM-dd")
}

export function getTodayYYYYMMDD(): string {
  return toYYYYMMDD(new Date())
}

export function getFinancialYearStart(monthMM: string): string {
  const d = new Date()
  const year = d.getFullYear()
  return ((d < new Date(year + "-" + monthMM + "-01")) ? year - 1 : year) + "-" + monthMM + "-01"
}

const DAYS_PATTERN = /(\d+)d/
const YEARS_PATTERN = /(\d+)y/

export function datePeriodStartDate(date: Date, datePeriod: string): Date {
  if (datePeriod === "wtd") {
    return subDays(date, getDay(date) - 1)
  } else if (datePeriod === "mtd") {
    return new Date(date.getFullYear(), date.getMonth(), 1)
  } else if (datePeriod === "ytd") {
    return new Date(date.getFullYear(), 0, 1)
  }
  const days = DAYS_PATTERN.exec(datePeriod)
  if (days) {
    return subDays(date, parseInt(days[0]) - 1)
  }
  const years = YEARS_PATTERN.exec(datePeriod)
  if (years) {
    return subYears(date, parseInt(years[0]))
  }
  throw new Error("Unsupported datePeriod: '" + datePeriod + "'")
}
